import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		flex: 1,
		overflow: `auto`,
	},
	noneFound: {
		color: '#4a4a4a',
		fontSize: 14,
		marginTop: 30,
		textAlign: 'center',
		width: '100%',
	},
});
